import '../styles/season-ticker.scss';